 export const dummyPackageData = [
      {
        id: "pkg-1",
        name: "Basic Haircut",
        description: "A simple haircut and styling package.",
        price: 1500,
        isActive: true,
      },
      {
        id: "pkg-2",
        name: "Premium Grooming",
        description: "Includes haircut, shave, and facial.",
        price: 3500,
        isActive: true,
      },
      {
        id: "pkg-3",
        name: "Bridal Makeup",
        description: "Full bridal makeup with hair styling.",
        price: 8000,
        isActive: false,
      },
    ];

export const  dummyOrdersData = [
        {
          id: "ord-001",
          referenceId: "REF12345",
          date: "2025-08-25 10:30 AM",
          note: "Please arrive 15 minutes early.",
          phoneNumber: "+94 771234567",
          name: "John Doe",
          place: "Colombo",
          package: {
            name: "Bridal Makeup",
            price: 8000,
          },
        },
        {
          id: "ord-002",
          referenceId: "REF67890",
          date: "2025-08-27 02:00 PM",
          note: "Customer requested home service.",
          phoneNumber: "+94 772345678",
          name: "Jane Smith",
          place: "Kandy",
          package: {
            name: "Haircut & Styling",
            price: 1500,
          },
        },
        {
          id: "ord-003",
          referenceId: "REF11223",
          date: "2025-08-30 11:00 AM",
          note: "First-time customer discount applied.",
          phoneNumber: "+94 773456789",
          name: "Michael Perera",
          place: "Galle",
          package: {
            name: "Premium Grooming",
            price: 3500,
          },
        },
      ];

export const dummyReviews = [
  {
    id: 1,
    name: "John Doe",
    referenceId: "REF12345",
    jobID: "JOB001",
    date: "2025-07-01",
    review: "Great service! Very professional and on time.",
    isActive: true,
  },
  {
    id: 2,
    name: "Jane Smith",
    referenceId: "REF12346",
    jobID: "JOB002",
    date: "2025-07-05",
    review: "Good experience overall, but could improve punctuality.",
    isActive: true,
  },
  {
    id: 3,
    name: "Michael Johnson",
    referenceId: "REF12347",
    jobID: "JOB003",
    date: "2025-07-10",
    review: "The work was excellent. Highly recommended!",
    isActive: true,
  },
  {
    id: 4,
    name: "Emily Davis",
    referenceId: "REF12348",
    jobID: "JOB004",
    date: "2025-07-15",
    review: "Not satisfied with the service, poor communication.",
    isActive: false,
  },
  {
    id: 5,
    name: "Daniel Wilson",
    referenceId: "REF12349",
    jobID: "JOB005",
    date: "2025-07-20",
    review: "Fantastic work, completed before deadline.",
    isActive: true,
  },
];


      